export const moduleId = 'reimbursementTask';

export const state = {
    lists: {},//账套信息
    costIsShow: false,//详情显示隐藏
    dialogzt: false,//账套显示隐藏
    flag: false,//是否可编辑
    orgId: '',
    isShow: true,
    orgList:null,//账套列表
    id: '',
    isDeapproval:false,
    isRouter:false,
    routeSource:false,
    isAdd: true,
    abId: '',
}
export const mutations = {
    setIsAdd(state, flag) {
        state.isAdd = flag
    },
    // setOrgId(state, id) {
    //     state.orgId = id
    // },
    // setTaskId(state, data) {
    //     state.id = data.id
    //     state.abId = data.abId
    // },
    //反审批
    setIsDeapproval(state,data){
        state.isDeapproval = data   
    },
    setRouteSource(state,data){
       state.routeSource = data
    },
    setCostIsShow(state, data) {
        state.costIsShow = data
    },
    setDialogzt(state, data) {
        state.dialogzt = data
    },
    setOrgList(state, data) {
        state.lists = data
    },
    setOrgLists(state, data) {
        state.orgList = data
    },
    setFalg(state, data) {
        state.flag = data
    },
    setIsRouter(state,data){
        state.isRouter = data
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/reimbursement-task/index.js